import React from "react";
import { storiesOf } from "@storybook/react";
import { withKnobs } from "@storybook/addon-knobs";
import withReadme from "storybook-readme/with-readme";
import Block from "@emcm-ui/component-block";
import { Language } from "@emcm-ui/component-theme";
import Panel from "./index";
import "./Panel.css";
import PanelREADME from "../README.md";

const stories = storiesOf("Components/Panel", module);

stories.addDecorator(withKnobs);
stories.addDecorator(withReadme(PanelREADME));

stories
  .add("Default", () => (
    <Panel>
      <Block color="orange" height="6rem" text="children" />
    </Panel>
  ))
  .add("Language: Arabic (RTL)", () => (
    <Language code="ar">
      <Panel>
        <Block color="orange" height="6rem" text="الأطفال" />
      </Panel>
    </Language>
  ));
